enum SortOrder {
  RANK = "rank",
  NAME = "name",
}

export default SortOrder;
